import React from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

export interface BasePriceVersionWarningProps {
    basePriceVersionId?: number | null;
    pricingVersions?: { id: number; name: string; created_on?: string }[] | null;
}

export default function BasePriceVersionWarning({ basePriceVersionId, pricingVersions }: BasePriceVersionWarningProps) {
    const latest = [...(pricingVersions ?? [])].sort((a, b) =>
        (Date.parse(b.created_on ?? '') - Date.parse(a.created_on ?? '')) || b.id - a.id)[0];
    if (basePriceVersionId == null || !latest || latest.id === basePriceVersionId) return null;
    const current = pricingVersions?.find(version => version.id === basePriceVersionId);
    const message = `You're using an older base price version (${current?.name || basePriceVersionId}). Resource rates use this version's catalog. Close this dialog and switch Base Pricing Version to ${latest.name || latest.id} for the latest rates. Existing proposed prices copied from a deal are retained.`;
    return <Tooltip title={message} trigger={['hover', 'focus', 'click']}>
        <button type="button" aria-label={message} style={{ marginLeft: 12, padding: '2px 6px',
            border: 0, background: 'transparent', color: '#ad6800', cursor: 'help', fontSize: 13, fontWeight: 400 }}>
            <WarningOutlined aria-hidden="true" /> Older base price version
        </button>
    </Tooltip>;
}
